import { render, staticRenderFns } from "./SettingOld.vue?vue&type=template&id=44277ae2&scoped=true"
import script from "./SettingOld.vue?vue&type=script&lang=js"
export * from "./SettingOld.vue?vue&type=script&lang=js"
import style0 from "./SettingOld.vue?vue&type=style&index=0&id=44277ae2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "44277ae2",
  null
  
)

export default component.exports